import { useQuery } from "@tanstack/react-query";
import { workClient } from "../clients/workClient";
import { useWorkScope } from "../components/WorkScopeProvider";
import { workRequestSchema } from "./useWorkRequestsQuery";

export function useWorkRequestQuery(workRequestId?: string) {
  const { selectedCustomer, selectedFacility } = useWorkScope();

  return useQuery({
    queryKey: [
      "work-request",
      selectedCustomer?.id,
      selectedFacility?.id,
      workRequestId,
    ],
    queryFn: async () => {
      if (!selectedCustomer || !selectedFacility || !workRequestId) {
        throw new Error(
          "A customer, facility, and Work Request must be selected.",
        );
      }

      const response = await workClient.v1.customers[":customerId"].facilities[
        ":facilityId"
      ].requests[":requestId"].$get({
        param: {
          customerId: selectedCustomer.id,
          facilityId: selectedFacility.id,
          requestId: workRequestId,
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch Work Request: ${response.status}`);
      }
      return workRequestSchema.parse(await response.json());
    },
    enabled: Boolean(selectedCustomer && selectedFacility && workRequestId),
    // A broken deep link fails fast: no retries (the request will not appear
    // on retry) and no toast — RequestsScreen shows an inline alert instead.
    retry: false,
  });
}
